// DS: MO3.4.3
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import DeviationShopCard from '../DeviationShopCard';
import AdoptableCardStats from './_partials/AdoptableCardStats';
import AdoptableDetailsRightSide from './_partials/AdoptableDetailsRightSide';
const AdoptableShopCard = (_param)=>{
    var { width, deviation, withAuthorDetails, withOwnerDetails, withIndicators, overrideHref, hidePrice, hideSold } = _param, deviationShopCardProps = _object_without_properties(_param, [
        "width",
        "deviation",
        "withAuthorDetails",
        "withOwnerDetails",
        "withIndicators",
        "overrideHref",
        "hidePrice",
        "hideSold"
    ]);
    return /*#__PURE__*/ React.createElement(DeviationShopCard, _object_spread({
        width: width,
        deviation: deviation,
        overrideHref: overrideHref,
        noCentsOnPrice: true,
        withStats: true,
        withDescriptionBlock: false,
        withAuthorDetails: withAuthorDetails,
        withIndicators: withIndicators,
        belowCoverImageRightSlot: /*#__PURE__*/ React.createElement(AdoptableCardStats, {
            deviation: deviation
        }),
        detailsRightSlot: /*#__PURE__*/ React.createElement(AdoptableDetailsRightSide, {
            deviation: deviation,
            hideSold: hideSold,
            hidePrice: hidePrice
        }),
        withOwnerDetails: withOwnerDetails
    }, deviationShopCardProps));
};
AdoptableShopCard.displayName = 'AdoptableShopCard';
export default AdoptableShopCard;
